import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { AnchorsServicePageConfig } from '../types'
import { name, VIEWER_SERVICE_PACKAGE_NAME } from '../symbols'

const anchorsServicePageConfig: PageConfigFn<AnchorsServicePageConfig> = (
	{ activeServices }: VsmContext,
	_pageId: string
) => {
	const shouldLoadPageFeature = activeServices.isActive(VIEWER_SERVICE_PACKAGE_NAME)

	return {
		shouldLoadPageFeature,
		pageConfig: {},
	}
}

export const pageConfig: PageConfigEntry<AnchorsServicePageConfig> = {
	name,
	configFactory: anchorsServicePageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
